export const SET_SITE_CARDS = 'SET_SITE_CARDS';
export const SET_SITE_CARDS_VISIBLE = 'SET_SITE_CARDS_VISIBLE';
export const SET_SITE_CARDS_FILTERS = 'SET_SITE_CARDS_FILTERS';

export const CREATE_SITE_CARD_REQUEST = 'CREATE_SITE_CARD_REQUEST';
export const CREATE_SITE_CARD_SUCCESS = 'CREATE_SITE_CARD_SUCCESS';
export const CREATE_SITE_CARD_FAILURE = 'CREATE_SITE_CARD_FAILURE';

export const CREATE_SITE_CARDS_REQUEST = 'CREATE_SITE_CARDS_REQUEST';
export const CREATE_SITE_CARDS_SUCCESS = 'CREATE_SITE_CARDS_SUCCESS';
export const CREATE_SITE_CARDS_FAILURE = 'CREATE_SITE_CARDS_FAILURE';

export const UPDATE_SITE_CARD_REQUEST = 'UPDATE_SITE_CARD_REQUEST';
export const UPDATE_SITE_CARD_SUCCESS = 'UPDATE_SITE_CARD_SUCCESS';
export const UPDATE_SITE_CARD_FAILURE = 'UPDATE_SITE_CARD_FAILURE';

export const DELETE_SITE_CARD_REQUEST = 'DELETE_SITE_CARD_REQUEST';
export const DELETE_SITE_CARD_SUCCESS = 'DELETE_SITE_CARD_SUCCESS';
export const DELETE_SITE_CARD_FAILURE = 'DELETE_SITE_CARD_FAILURE';

export const FETCH_SITE_CARDS_REQUEST = 'FETCH_SITE_CARDS_REQUEST';
export const FETCH_SITE_CARDS_SUCCESS = 'FETCH_SITE_CARDS_SUCCESS';
export const FETCH_SITE_CARDS_FAILURE = 'FETCH_SITE_CARDS_FAILURE';

export const EXPORT_SITE_CARD_REQUEST = 'EXPORT_SITE_CARD_REQUEST';
export const EXPORT_SITE_CARD_SUCCESS = 'EXPORT_SITE_CARD_SUCCESS';
export const EXPORT_SITE_CARD_FAILURE = 'EXPORT_SITE_CARD_FAILURE';

export interface IExportSiteCardRequestAction {
    type: string;
    error?: any;
}
